/**
 * ec-desc-expand.js
 * Adds "Read more / Show less" toggle to product card descriptions.
 * Truncates to ~120 chars on card, expands inline on click.
 */
(function () {
  var TRUNCATE_LEN = 120;

  function initExpand() {
    var descs = document.querySelectorAll('[data-ec-desc-handle]');
    descs.forEach(function (el) {
      var fullText = el.textContent.trim();
      if (!fullText || fullText.length <= TRUNCATE_LEN) return;
      // Avoid double-init
      if (el.dataset.ecExpandInit) return;
      el.dataset.ecExpandInit = '1';

      var short = fullText.slice(0, TRUNCATE_LEN).trimEnd() + '\u2026';

      // Build wrapper
      el.textContent = '';

      var textSpan = document.createElement('span');
      textSpan.textContent = short;
      textSpan.style.cssText = 'display:inline;';

      var btn = document.createElement('button');
      btn.textContent = ' Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.style.cssText = [
        'background:none',
        'border:none',
        'padding:0',
        'margin-left:2px',
        'cursor:pointer',
        'font-size:inherit',
        'font-family:inherit',
        'line-height:inherit',
        'color:#0277D6',
        'font-weight:600',
        'text-decoration:underline',
        'text-underline-offset:2px',
        'white-space:nowrap',
        'transition:color 0.15s',
      ].join(';');

      btn.addEventListener('mouseenter', function () {
        btn.style.color = '#025bb0';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.color = '#0277D6';
      });

      var expanded = false;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        expanded = !expanded;
        if (expanded) {
          textSpan.textContent = fullText + ' ';
          btn.textContent = 'Show less';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          textSpan.textContent = short;
          btn.textContent = ' Read more';
          btn.setAttribute('aria-expanded', 'false');
        }
      });

      el.appendChild(textSpan);
      el.appendChild(btn);
    });
  }

  // Run after initial render
  function tryInit() {
    initExpand();
    // Also re-run after desc sync fires
    window.addEventListener('ecDescLoaded', function () {
      // Give React a tick to update DOM text
      setTimeout(initExpand, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    // DOM already ready. wait a tick for React to mount
    setTimeout(tryInit, 200);
  }

  // Also re-run when filter changes (React re-renders cards)
  var _lastFilter = null;
  setInterval(function () {
    var activeBtn = document.querySelector('[data-ec-filter-active]');
    var current = activeBtn ? activeBtn.textContent : 'all';
    if (current !== _lastFilter) {
      _lastFilter = current;
      setTimeout(initExpand, 100);
    }
  }, 300);
})();

/**
 * Shopify CAPTCHA fix. appended to ec-desc-expand.js
 * Sets data-shopify-captcha="true" on the ContactForm and NewsletterCaptchaForm
 * so that Shopify.captcha.protect() can intercept submissions.
 * This runs even when the browser loads a cached version of the page HTML.
 */
(function () {
  'use strict';
  function patchForm(form) {
    if (!form || form.getAttribute('data-captcha-patched')) return;
    form.setAttribute('data-shopify-captcha', 'true');
    form.setAttribute('data-captcha-patched', 'true');
  }
  function patchAllForms() {
    patchForm(document.getElementById('ContactForm'));
    patchForm(document.getElementById('NewsletterCaptchaForm'));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(patchAllForms, 200);
    });
  } else {
    setTimeout(patchAllForms, 200);
  }
  if (window.MutationObserver) {
    var captchaObserver = new MutationObserver(function () {
      patchAllForms();
    });
    function startCaptchaObserver() {
      if (document.body) {
        captchaObserver.observe(document.body, { childList: true, subtree: true });
      }
    }
    if (document.body) {
      startCaptchaObserver();
    } else {
      document.addEventListener('DOMContentLoaded', startCaptchaObserver);
    }
  }
})();
